// @flow

import type {
  PropsSchema,
  BasicProps,
  EasyCompMap,
  EasyAction
} from '../../type'
import { customRender, originCallActions } from '../EasyCompComponent'
import * as React from 'react'
import computeData from '../hoc/computeData'

type Props = BasicProps & {
  children?: Array<EasyCompMap>,
  style: { [string]: string },
  schema: any,
  customProps?: any,
  events: any,
  compId: string,
  events: any,
  actions?: EasyAction[]
};

@computeData()
export default class Folder extends React.PureComponent<Props> {
  static schema: PropsSchema = [
    {
      type: 'code',
      key: 'schema',
      title: '配置信息'
    },
    'separator',
    {
      key: 'actions',
      title: '动作',
      type: 'array',
      item: [
        {
          type: 'text',
          key: 'name',
          title: '动作名称'
        },
        {
          type: 'text',
          key: 'title',
          title: '动作标题'
        },
        {
          type: 'json',
          key: 'dataSchema',
          title: '动作配置'
        },
        {
          type: 'event',
          title: '动作触发事件',
          event: 'events'
        }
      ]
    }
  ];

  static actions: EasyAction[] = [
    {
      title: '调用自定义事件',
      name: 'callEvent',
      dataSchema: [
        {
          key: 'eventName',
          title: '事件名称',
          required: true
        }
      ]
    }
  ];

  componentDidMount () {
    let { callActions } = this.props
    callActions('ready')
  }

  actionCallEvent = (
    { eventName }: { eventName: string },
    dynamicData: any
  ) => {
    let { callActions } = this.props
    callActions(eventName, dynamicData)
  };

  actionForward = (
    actionName: string,
    data: any = {},
    dynamicData: any = {}
  ) => {
    const { compId, actions = [], jsEnv, customProps } = this.props
    const targetAction = actions.filter(action => action.name === actionName)
    let events
    if (targetAction && targetAction.length > 0) {
      events = targetAction[0].events
    }
    dynamicData.$comp = this.get$comp()
    if (events) {
      originCallActions({
        compId,
        events,
        eventName: actionName,
        dynamicData: { ...data, ...dynamicData },
        jsEnv,
        ...(customProps && customProps.$indexes
          ? {
            iteratorIndex: customProps.$indexes.join(',')
          }
          : {})
      })
    }
  };

  get$comp = () => {
    const { schema, jsEnv, events } = this.props
    let $comp = { events }
    if (schema) {
      let jsonSchema = schema
      if (typeof schema === 'string') {
        jsonSchema = jsEnv.runCode(schema)
      }
      if (Array.isArray(jsonSchema)) {
        jsonSchema.forEach(item => {
          if (item && item.key) {
            $comp[item.key] = this.props[item.key]
          }
        })
      }
    }
    return $comp
  };

  render () {
    if (!this.props.visible) {
      return null
    }
    const {
      id,
      children,
      style,
      customProps: parentCustomProps = {}
    } = this.props
    let $comp = this.get$comp()
    let { $propsNames = [], $indexes } = parentCustomProps
    let customProps = {
      $comp,
      $propsNames: [...$propsNames, '$comp']
    }
    $propsNames.forEach(key => {
      customProps[key] = parentCustomProps[key]
    })
    return (
      <div id={id} style={style}>
        {children &&
          customRender(
            children,
            {
              customProps
            },
            $indexes
          )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/complex/Complex.js